import React, {
    useState,
} from "react";
import { Card, CardContent } from "@mui/material";
import {Download} from "react-feather";
import Tab from "../../components/Tab";
import "react-toastify/dist/ReactToastify.css";
import {
    FORMS,
    MODULES,
} from "../../const";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import PerformanceFinanceScreen from "../../components/transaction/performance-finance-report/PerformanceFinanceScreen";

const form = FORMS.MIS.REPORT.form;

function PerformanceFinanceReport() {
    useParams();
    useSelector(
        (state) => state.user.permissions[MODULES.Transaction],
    );
    const [tab, setTab] = useState(1);

    return (
        <div>
            <Card>
                <CardContent>
                    <div className="ui tabular menu top attached">
                        <Tab
                            Icon={Download}
                            onClick={() => {
                                setTab(1);
                            }}
                            active={tab === 1}
                            label="Performance Finance Report"
                        />
                    </div>
                    <>
                        <div
                            className="ui bottom attached active tab segment"
                            style={{ display: tab === 1 ? "block" : "none" }}
                        >
                            <PerformanceFinanceScreen />
                        </div>
                    </>
                </CardContent>
            </Card>
        </div>
    );
}

export default PerformanceFinanceReport;
